// Per-state facts for the /paystub-generator landing pages. Recovered from
// the original StatePaystubGenerator page (pre-/app era) — tax rates, wage
// and compliance notes reviewed for that launch. Figures are indicative;
// pages carry a verify-with-your-state disclaimer.
export const STATE_DATA = {
  'alabama': {
    name: 'Alabama',
    abbr: 'AL',
    taxRate: '2% - 5%',
    hasStateTax: true,
    majorCities: ['Birmingham', 'Montgomery', 'Mobile', 'Huntsville'],
    population: '5.1 million',
    minWage: '$7.25',
    compliance: 'Alabama follows federal FLSA guidelines for pay stub requirements. While Alabama does not mandate specific pay stub information, employers must provide accurate wage documentation.',
  },
  'alaska': {
    name: 'Alaska',
    abbr: 'AK',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Anchorage', 'Fairbanks', 'Juneau', 'Sitka'],
    population: '733,000',
    minWage: '$11.73',
    compliance: 'Alaska is one of the few states with no state income tax. Employers must still comply with federal wage and hour laws.',
  },
  'arizona': {
    name: 'Arizona',
    abbr: 'AZ',
    taxRate: '2.5%',
    hasStateTax: true,
    majorCities: ['Phoenix', 'Tucson', 'Mesa', 'Scottsdale'],
    population: '7.3 million',
    minWage: '$14.35',
    compliance: 'Arizona requires employers to provide itemized pay statements showing gross wages, deductions, and net pay.',
  },
  'arkansas': {
    name: 'Arkansas',
    abbr: 'AR',
    taxRate: '2% - 4.7%',
    hasStateTax: true,
    majorCities: ['Little Rock', 'Fort Smith', 'Fayetteville', 'Springdale'],
    population: '3.0 million',
    minWage: '$11.00',
    compliance: 'Arkansas employers must provide pay stubs with hours worked, pay rate, and itemized deductions.',
  },
  'california': {
    name: 'California',
    abbr: 'CA',
    taxRate: '1% - 13.3%',
    hasStateTax: true,
    majorCities: ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose'],
    population: '39 million',
    minWage: '$16.00',
    compliance: 'California Labor Code Section 226 requires detailed pay stubs including gross wages, total hours, piece rates, deductions, net wages, pay period dates, employee name and ID, and employer information.',
  },
  'colorado': {
    name: 'Colorado',
    abbr: 'CO',
    taxRate: '4.4%',
    hasStateTax: true,
    majorCities: ['Denver', 'Colorado Springs', 'Aurora', 'Fort Collins'],
    population: '5.8 million',
    minWage: '$14.42',
    compliance: 'Colorado requires employers to provide written statements of earnings and deductions with each pay period.',
  },
  'connecticut': {
    name: 'Connecticut',
    abbr: 'CT',
    taxRate: '3% - 6.99%',
    hasStateTax: true,
    majorCities: ['Bridgeport', 'New Haven', 'Hartford', 'Stamford'],
    population: '3.6 million',
    minWage: '$15.69',
    compliance: 'Connecticut requires itemized wage statements showing hours worked, gross pay, itemized deductions, and net pay.',
  },
  'delaware': {
    name: 'Delaware',
    abbr: 'DE',
    taxRate: '2.2% - 6.6%',
    hasStateTax: true,
    majorCities: ['Wilmington', 'Dover', 'Newark', 'Middletown'],
    population: '1.0 million',
    minWage: '$13.25',
    compliance: 'Delaware requires employers to furnish employees with a statement of deductions made from wages.',
  },
  'florida': {
    name: 'Florida',
    abbr: 'FL',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Miami', 'Orlando', 'Tampa', 'Jacksonville'],
    population: '22 million',
    minWage: '$13.00',
    compliance: 'Florida has no state income tax. While pay stub laws are minimal, employers should provide documentation for federal compliance.',
  },
  'georgia': {
    name: 'Georgia',
    abbr: 'GA',
    taxRate: '1% - 5.49%',
    hasStateTax: true,
    majorCities: ['Atlanta', 'Augusta', 'Columbus', 'Savannah'],
    population: '10.9 million',
    minWage: '$7.25',
    compliance: 'Georgia requires employers to provide pay stubs showing gross pay, deductions, and net pay with each payment.',
  },
  'hawaii': {
    name: 'Hawaii',
    abbr: 'HI',
    taxRate: '1.4% - 11%',
    hasStateTax: true,
    majorCities: ['Honolulu', 'Pearl City', 'Hilo', 'Kailua'],
    population: '1.4 million',
    minWage: '$14.00',
    compliance: 'Hawaii requires detailed pay statements including hours, wages, and all deductions.',
  },
  'idaho': {
    name: 'Idaho',
    abbr: 'ID',
    taxRate: '5.8%',
    hasStateTax: true,
    majorCities: ['Boise', 'Meridian', 'Nampa', 'Idaho Falls'],
    population: '1.9 million',
    minWage: '$7.25',
    compliance: 'Idaho follows federal requirements for pay documentation.',
  },
  'illinois': {
    name: 'Illinois',
    abbr: 'IL',
    taxRate: '4.95%',
    hasStateTax: true,
    majorCities: ['Chicago', 'Aurora', 'Naperville', 'Rockford'],
    population: '12.6 million',
    minWage: '$14.00',
    compliance: 'Illinois requires employers to provide itemized pay stubs with hours worked, pay rates, and deductions.',
  },
  'indiana': {
    name: 'Indiana',
    abbr: 'IN',
    taxRate: '3.05%',
    hasStateTax: true,
    majorCities: ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend'],
    population: '6.8 million',
    minWage: '$7.25',
    compliance: 'Indiana requires employers to provide written pay statements with each wage payment.',
  },
  'iowa': {
    name: 'Iowa',
    abbr: 'IA',
    taxRate: '4.4% - 5.7%',
    hasStateTax: true,
    majorCities: ['Des Moines', 'Cedar Rapids', 'Davenport', 'Sioux City'],
    population: '3.2 million',
    minWage: '$7.25',
    compliance: 'Iowa requires employers to provide detailed wage statements with each pay period.',
  },
  'kansas': {
    name: 'Kansas',
    abbr: 'KS',
    taxRate: '3.1% - 5.7%',
    hasStateTax: true,
    majorCities: ['Wichita', 'Overland Park', 'Kansas City', 'Topeka'],
    population: '2.9 million',
    minWage: '$7.25',
    compliance: 'Kansas requires itemized pay statements showing gross wages and deductions.',
  },
  'kentucky': {
    name: 'Kentucky',
    abbr: 'KY',
    taxRate: '4%',
    hasStateTax: true,
    majorCities: ['Louisville', 'Lexington', 'Bowling Green', 'Owensboro'],
    population: '4.5 million',
    minWage: '$7.25',
    compliance: 'Kentucky requires employers to provide detailed earnings statements with each payment.',
  },
  'louisiana': {
    name: 'Louisiana',
    abbr: 'LA',
    taxRate: '1.85% - 4.25%',
    hasStateTax: true,
    majorCities: ['New Orleans', 'Baton Rouge', 'Shreveport', 'Lafayette'],
    population: '4.6 million',
    minWage: '$7.25',
    compliance: 'Louisiana requires employers to provide itemized statements of earnings and deductions.',
  },
  'maine': {
    name: 'Maine',
    abbr: 'ME',
    taxRate: '5.8% - 7.15%',
    hasStateTax: true,
    majorCities: ['Portland', 'Lewiston', 'Bangor', 'Auburn'],
    population: '1.4 million',
    minWage: '$14.15',
    compliance: 'Maine requires detailed pay statements with every wage payment.',
  },
  'maryland': {
    name: 'Maryland',
    abbr: 'MD',
    taxRate: '2% - 5.75%',
    hasStateTax: true,
    majorCities: ['Baltimore', 'Frederick', 'Rockville', 'Gaithersburg'],
    population: '6.2 million',
    minWage: '$15.00',
    compliance: 'Maryland requires employers to provide written statements showing hours, wages, and deductions.',
  },
  'massachusetts': {
    name: 'Massachusetts',
    abbr: 'MA',
    taxRate: '5%',
    hasStateTax: true,
    majorCities: ['Boston', 'Worcester', 'Springfield', 'Cambridge'],
    population: '7.0 million',
    minWage: '$15.00',
    compliance: 'Massachusetts requires detailed pay stubs including hours worked, gross/net pay, and itemized deductions.',
  },
  'michigan': {
    name: 'Michigan',
    abbr: 'MI',
    taxRate: '4.25%',
    hasStateTax: true,
    majorCities: ['Detroit', 'Grand Rapids', 'Warren', 'Ann Arbor'],
    population: '10.0 million',
    minWage: '$10.33',
    compliance: 'Michigan requires employers to provide itemized pay statements with each payment.',
  },
  'minnesota': {
    name: 'Minnesota',
    abbr: 'MN',
    taxRate: '5.35% - 9.85%',
    hasStateTax: true,
    majorCities: ['Minneapolis', 'St. Paul', 'Rochester', 'Duluth'],
    population: '5.7 million',
    minWage: '$10.85',
    compliance: 'Minnesota requires comprehensive earnings statements with each wage payment.',
  },
  'mississippi': {
    name: 'Mississippi',
    abbr: 'MS',
    taxRate: '4% - 5%',
    hasStateTax: true,
    majorCities: ['Jackson', 'Gulfport', 'Southaven', 'Biloxi'],
    population: '2.9 million',
    minWage: '$7.25',
    compliance: 'Mississippi follows federal pay stub requirements.',
  },
  'missouri': {
    name: 'Missouri',
    abbr: 'MO',
    taxRate: '2% - 4.95%',
    hasStateTax: true,
    majorCities: ['Kansas City', 'St. Louis', 'Springfield', 'Columbia'],
    population: '6.2 million',
    minWage: '$12.30',
    compliance: 'Missouri requires employers to provide itemized wage statements.',
  },
  'montana': {
    name: 'Montana',
    abbr: 'MT',
    taxRate: '4.7% - 5.9%',
    hasStateTax: true,
    majorCities: ['Billings', 'Missoula', 'Great Falls', 'Bozeman'],
    population: '1.1 million',
    minWage: '$10.30',
    compliance: 'Montana requires detailed pay statements with each wage payment.',
  },
  'nebraska': {
    name: 'Nebraska',
    abbr: 'NE',
    taxRate: '2.46% - 5.84%',
    hasStateTax: true,
    majorCities: ['Omaha', 'Lincoln', 'Bellevue', 'Grand Island'],
    population: '2.0 million',
    minWage: '$12.00',
    compliance: 'Nebraska requires employers to provide written wage statements.',
  },
  'nevada': {
    name: 'Nevada',
    abbr: 'NV',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Las Vegas', 'Henderson', 'Reno', 'North Las Vegas'],
    population: '3.2 million',
    minWage: '$12.00',
    compliance: 'Nevada has no state income tax. Employers must provide written wage statements showing hours, wages, and deductions.',
  },
  'new-hampshire': {
    name: 'New Hampshire',
    abbr: 'NH',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Manchester', 'Nashua', 'Concord', 'Derry'],
    population: '1.4 million',
    minWage: '$7.25',
    compliance: 'New Hampshire has no state income tax on wages. Employers must provide itemized pay statements.',
  },
  'new-jersey': {
    name: 'New Jersey',
    abbr: 'NJ',
    taxRate: '1.4% - 10.75%',
    hasStateTax: true,
    majorCities: ['Newark', 'Jersey City', 'Paterson', 'Elizabeth'],
    population: '9.3 million',
    minWage: '$15.13',
    compliance: 'New Jersey requires comprehensive pay statements with each wage payment.',
  },
  'new-mexico': {
    name: 'New Mexico',
    abbr: 'NM',
    taxRate: '1.7% - 5.9%',
    hasStateTax: true,
    majorCities: ['Albuquerque', 'Las Cruces', 'Rio Rancho', 'Santa Fe'],
    population: '2.1 million',
    minWage: '$12.00',
    compliance: 'New Mexico requires employers to provide detailed wage statements.',
  },
  'new-york': {
    name: 'New York',
    abbr: 'NY',
    taxRate: '4% - 10.9%',
    hasStateTax: true,
    majorCities: ['New York City', 'Buffalo', 'Rochester', 'Syracuse'],
    population: '19.3 million',
    minWage: '$15.00',
    compliance: 'New York Labor Law Section 195 requires detailed pay stubs including hours, rates, deductions, and employer information.',
  },
  'north-carolina': {
    name: 'North Carolina',
    abbr: 'NC',
    taxRate: '4.75%',
    hasStateTax: true,
    majorCities: ['Charlotte', 'Raleigh', 'Greensboro', 'Durham'],
    population: '10.7 million',
    minWage: '$7.25',
    compliance: 'North Carolina requires employers to provide itemized wage statements.',
  },
  'north-dakota': {
    name: 'North Dakota',
    abbr: 'ND',
    taxRate: '1.1% - 2.5%',
    hasStateTax: true,
    majorCities: ['Fargo', 'Bismarck', 'Grand Forks', 'Minot'],
    population: '779,000',
    minWage: '$7.25',
    compliance: 'North Dakota requires written earnings statements with each payment.',
  },
  'ohio': {
    name: 'Ohio',
    abbr: 'OH',
    taxRate: '0% - 3.5%',
    hasStateTax: true,
    majorCities: ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo'],
    population: '11.8 million',
    minWage: '$10.45',
    compliance: 'Ohio requires employers to provide itemized pay statements showing hours, wages, and deductions.',
  },
  'oklahoma': {
    name: 'Oklahoma',
    abbr: 'OK',
    taxRate: '0.25% - 4.75%',
    hasStateTax: true,
    majorCities: ['Oklahoma City', 'Tulsa', 'Norman', 'Broken Arrow'],
    population: '4.0 million',
    minWage: '$7.25',
    compliance: 'Oklahoma requires employers to provide itemized wage statements.',
  },
  'oregon': {
    name: 'Oregon',
    abbr: 'OR',
    taxRate: '4.75% - 9.9%',
    hasStateTax: true,
    majorCities: ['Portland', 'Salem', 'Eugene', 'Gresham'],
    population: '4.2 million',
    minWage: '$14.20',
    compliance: 'Oregon requires detailed itemized pay statements with each wage payment.',
  },
  'pennsylvania': {
    name: 'Pennsylvania',
    abbr: 'PA',
    taxRate: '3.07%',
    hasStateTax: true,
    majorCities: ['Philadelphia', 'Pittsburgh', 'Allentown', 'Reading'],
    population: '13.0 million',
    minWage: '$7.25',
    compliance: 'Pennsylvania requires employers to provide written wage statements.',
  },
  'rhode-island': {
    name: 'Rhode Island',
    abbr: 'RI',
    taxRate: '3.75% - 5.99%',
    hasStateTax: true,
    majorCities: ['Providence', 'Warwick', 'Cranston', 'Pawtucket'],
    population: '1.1 million',
    minWage: '$14.00',
    compliance: 'Rhode Island requires itemized pay statements with each wage payment.',
  },
  'south-carolina': {
    name: 'South Carolina',
    abbr: 'SC',
    taxRate: '0% - 6.4%',
    hasStateTax: true,
    majorCities: ['Charleston', 'Columbia', 'North Charleston', 'Greenville'],
    population: '5.3 million',
    minWage: '$7.25',
    compliance: 'South Carolina requires employers to provide written wage statements.',
  },
  'south-dakota': {
    name: 'South Dakota',
    abbr: 'SD',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Sioux Falls', 'Rapid City', 'Aberdeen', 'Brookings'],
    population: '909,000',
    minWage: '$11.20',
    compliance: 'South Dakota has no state income tax. Employers follow federal pay stub guidelines.',
  },
  'tennessee': {
    name: 'Tennessee',
    abbr: 'TN',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Nashville', 'Memphis', 'Knoxville', 'Chattanooga'],
    population: '7.1 million',
    minWage: '$7.25',
    compliance: 'Tennessee has no state income tax. Employers should provide documentation per federal requirements.',
  },
  'texas': {
    name: 'Texas',
    abbr: 'TX',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Houston', 'San Antonio', 'Dallas', 'Austin'],
    population: '30.5 million',
    minWage: '$7.25',
    compliance: 'Texas has no state income tax. While specific pay stub laws are minimal, employers must comply with federal FLSA requirements.',
  },
  'utah': {
    name: 'Utah',
    abbr: 'UT',
    taxRate: '4.65%',
    hasStateTax: true,
    majorCities: ['Salt Lake City', 'West Valley City', 'Provo', 'West Jordan'],
    population: '3.4 million',
    minWage: '$7.25',
    compliance: 'Utah requires employers to provide itemized pay statements.',
  },
  'vermont': {
    name: 'Vermont',
    abbr: 'VT',
    taxRate: '3.35% - 8.75%',
    hasStateTax: true,
    majorCities: ['Burlington', 'South Burlington', 'Rutland', 'Barre'],
    population: '647,000',
    minWage: '$13.67',
    compliance: 'Vermont requires detailed itemized pay statements with each wage payment.',
  },
  'virginia': {
    name: 'Virginia',
    abbr: 'VA',
    taxRate: '2% - 5.75%',
    hasStateTax: true,
    majorCities: ['Virginia Beach', 'Norfolk', 'Chesapeake', 'Richmond'],
    population: '8.6 million',
    minWage: '$12.00',
    compliance: 'Virginia requires employers to provide itemized pay statements showing wages and deductions.',
  },
  'washington': {
    name: 'Washington',
    abbr: 'WA',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Seattle', 'Spokane', 'Tacoma', 'Vancouver'],
    population: '7.8 million',
    minWage: '$16.28',
    compliance: 'Washington has no state income tax. Employers must provide detailed pay statements showing hours, pay rate, and deductions.',
  },
  'west-virginia': {
    name: 'West Virginia',
    abbr: 'WV',
    taxRate: '2.36% - 5.12%',
    hasStateTax: true,
    majorCities: ['Charleston', 'Huntington', 'Morgantown', 'Parkersburg'],
    population: '1.8 million',
    minWage: '$8.75',
    compliance: 'West Virginia requires employers to provide itemized wage statements.',
  },
  'wisconsin': {
    name: 'Wisconsin',
    abbr: 'WI',
    taxRate: '3.54% - 7.65%',
    hasStateTax: true,
    majorCities: ['Milwaukee', 'Madison', 'Green Bay', 'Kenosha'],
    population: '5.9 million',
    minWage: '$7.25',
    compliance: 'Wisconsin requires employers to provide written wage statements with each payment.',
  },
  'wyoming': {
    name: 'Wyoming',
    abbr: 'WY',
    taxRate: '0%',
    hasStateTax: false,
    majorCities: ['Cheyenne', 'Casper', 'Laramie', 'Gillette'],
    population: '577,000',
    minWage: '$7.25',
    compliance: 'Wyoming has no state income tax. Employers follow federal pay stub requirements.',
  },
  'canada': {
    name: 'Canada',
    abbr: 'CA',
    taxRate: '15% - 33% Federal',
    hasStateTax: true,
    majorCities: ['Toronto', 'Vancouver', 'Montreal', 'Calgary'],
    population: '40 million',
    minWage: 'Varies by province',
    compliance: 'Canadian employers must provide pay stubs showing gross pay, deductions (CPP, EI, income tax), and net pay per provincial Employment Standards Acts.',
  },
};

export const STATE_SLUGS = Object.keys(STATE_DATA).filter((s) => s !== "canada");
